import eqCondition from './eq';
import gtCondition from './gt';

function gte(number) {
  return function check(value) {
    return gtCondition(number)(value) || eqCondition(number)(value);
  };
}

export default gte;
